import { useTranslation } from 'react-i18next';
import { useLanguage } from '../hooks/useLanguage';

// EN/IT/ES/FR/DE toggle (ES dal 2026-09-16, FR dal 2026-09-17, DE dal 2026-09-18) — used both in the public nav and inside the Vault (see
// hooks/useLanguage.js for how the choice is persisted). Switches the UI
// in place; never navigates to a separate URL/path for the language.
export default function LanguageSwitcher({ className = '' }) {
  const { language, changeLanguage } = useLanguage();
  const { t } = useTranslation('common');

  return (
    <div className={`lang-switcher ${className}`} role="group" aria-label={t('language_label')}>
      <button
        type="button"
        className={language === 'en' ? 'active' : ''}
        onClick={() => changeLanguage('en')}
        aria-pressed={language === 'en'}
      >EN</button>
      <button
        type="button"
        className={language === 'it' ? 'active' : ''}
        onClick={() => changeLanguage('it')}
        aria-pressed={language === 'it'}
      >IT</button>
      <button
        type="button"
        className={language === 'es' ? 'active' : ''}
        onClick={() => changeLanguage('es')}
        aria-pressed={language === 'es'}
      >ES</button>
      <button
        type="button"
        className={language === 'fr' ? 'active' : ''}
        onClick={() => changeLanguage('fr')}
        aria-pressed={language === 'fr'}
      >FR</button>
      <button
        type="button"
        className={language === 'de' ? 'active' : ''}
        onClick={() => changeLanguage('de')}
        aria-pressed={language === 'de'}
      >DE</button>
    </div>
  );
}
